// Same surface and hover as the docs `IconBox` cards, with no border stroke.
.root {
	display: flex;
	flex-direction: column;
	gap: var(--mantine-spacing-xs);
	height: 100%;
	background: var(--docs-card);
	// Older labs recede (`labAgeOpacity`), and come back to full strength when
	// a reader points at, focuses or selects one.
	opacity: var(--lab-age-opacity, 1);
	transition: opacity 150ms ease;

	&[data-selected],
	.anchor:focus-visible & {
		opacity: 1;
	}

	@media (prefers-contrast: more) {
		opacity: 1;
	}

	// Hover lifts the surface and puts the accent on the title alone - the
	// same move the nav dropdown items make - instead of tinting every
	// inheriting label in the card.
	.anchor:hover & {
		opacity: 1;
		background: var(--docs-card-hover);

		.title {
			color: var(--docs-accent-text);
		}

		.description {
			color: var(--mantine-color-text);
		}

		.open {
			opacity: 1;
			color: var(--docs-accent-text);
		}
	}
}

// The kicker the nav dropdowns use for their section labels, so the category
// reads as an eyebrow above the title.
.category {
	flex-shrink: 0;
	font-family: var(--mantine-font-family-monospace);
	font-size: 0.75rem;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.08em;
	color: var(--mantine-color-slate-3);

	@include light {
		color: var(--mantine-color-slate-6);
	}
}

.title {
	transition: color 200ms ease;
}

.description {
	transition: color 200ms ease;
}

// Official entries carry the brand mark on the product accent - solid pink
// on the Database docs - with the glyph knocked out in white.
.official-avatar {
	:global(.mantine-Avatar-placeholder) {
		background: var(--docs-accent);
		color: var(--docs-accent-contrast);
	}
}

// External-link affordance: hidden until the card is hovered. The avatar and
// names stay centred on each other; only the arrow drops to the row's bottom
// line.
.open {
	flex-shrink: 0;
	align-self: flex-end;
	opacity: 0;
	color: var(--mantine-color-slate-3);
	transition: opacity 200ms ease, color 200ms ease;

	@include light {
		color: var(--mantine-color-slate-6);
	}
}

// Light mode draws the edge with a 1px line instead of a fill.
.root {
	@include light {
		border: 1px solid var(--surreal-border-default);
	}
}

// A card picked for the share link carries the product accent as its edge.
.root[data-selected] {
	outline: 2px solid var(--docs-accent);
	outline-offset: -2px;
}
